import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import {
    Layout,
    Menu,
    Button,
    FloatButton,
    Space,
    Typography,
    Card,
    Avatar,
    Tag,
    Dropdown,
    Modal,
    theme,
} from "antd";
import { PiChats, PiStudent } from "react-icons/pi";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaTasks } from "react-icons/fa";
import { BiEdit, BiPlus, BiMinus, BiRefresh } from "react-icons/bi";
import { GiCancel } from "react-icons/gi";
import { TbMessageCircleQuestion } from "react-icons/tb";
import { IoChatboxEllipsesOutline, IoOptions } from "react-icons/io5";
import { DownOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { DeleteAulaIdProjecte } from "../../../dao/DeleteAulaIdProjecte";
import { DeleteAulaIdProjectesIdTasques } from "../../../dao/DeleteAulaIdProjectesIdTasques";
import { motion } from "framer-motion";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";

import AulaIdConfiguracio from "./content/AulaIdConfiguracio";
import ProjecteModal from "./content/ProjecteModal";
import TascaModal from "../aulaIdProjecteId/content/TascaModal";
import DudaTextoModal from "../content/DudaTextoModal";
import ChatModal from "../../jutge/components/ChatModal";
import ChatTableModal from "../../jutge/components/ChatTableModal";
import CuaModal from "../../jutge/components/CuaModal";

import { GetAllAules } from "../../../dao/GetAllAules";
import { GetAlumneId } from "../../../dao/GetAlumneId";
import { GetAules } from "../../../dao/GetAules";
import { GetAulesIdProjecteIdTasques } from "../../../dao/GetAulesIdProjecteIdTasques";
import { GetAulaIdProjecteIdTasquesId } from "../../../dao/GetAulaIdProjecteIdTasquesId";
import { PostDuda } from "../../../dao/PostDuda";
import { DeleteDuda } from "../../../dao/DeleteDuda";
import { GetInteraccionsId } from "../../../dao/GetInteraccionsId";
import { GetInteraccionsIdTasca } from "../../../dao/GetInteraccionsIdTasca";

import HomeColors from "../../../styles/HomeColors";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import itemsIA from "../../jutge/problemesId/content/SortirCuaArrayIA";
import items from "../../jutge/problemesId/content/SortirCuaArray";

const { Sider, Content } = Layout;
const { Text, Title, Paragraph } = Typography;

const AulesId = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_aula, id_projecte, id_tasca } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [aula, setAula] = useState<any>(null);
    const [projectesTasques, setProjectesTasques] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [tascaSeleccionada, setTascaSeleccionada] = useState<any>(null);

    // Modal States
    const [projecteModal, setProjecteModal] = useState(false);
    const [tascaModal, setTascaModal] = useState(false);
    const [selectedProjecte, setSelectedProjecte] = useState<any>(null);
    const [selectedTasca, setSelectedTasca] = useState<any>(null);

    const [conversaModal, setConversaModal] = useState(false);
    const [dubtesModal, setDubtesModal] = useState(false);
    const [dudaTextoModal, setDudaTextoModal] = useState(false);
    const [chatVisible, setChatVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<any>(null);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const isProfe = user.tipus === "1" || user.tipus === "0";

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_aula, id_projecte, id_tasca]);

    async function checkDades(forceRefresh: boolean = true) {
        setLoading(true);
        try {
            // Obtener aula
            const allAules = await GetAules(userId);
            const actAula = allAules?.find((a: any) => a.id == id_aula);
            setAula(actAula);

            if (actAula) {
                // Fetch tasques para todos los projectes
                const prTree = [];
                if (actAula.projectes) {
                    for (let proj of actAula.projectes) {
                        try {
                            const tsqs = await GetAulesIdProjecteIdTasques(
                                actAula.id + "",
                                proj.id + "",
                            );
                            prTree.push({ projecte: proj, tasques: tsqs || [] });
                        } catch (e) {
                            prTree.push({ projecte: proj, tasques: [] });
                        }
                    }
                }
                setProjectesTasques(prTree);
            }

            // Establecer breadcrumb
            let breadcrumb = [
                { nom: "Home", nav: "/home" },
                { nom: "Aules", nav: "/home" },
                { nom: actAula?.nom || "Aula", nav: `/home/aules/${id_aula}` },
            ];

            if (id_projecte) {
                const pName =
                    actAula?.projectes?.find((p: any) => p.id == id_projecte)?.nom ||
                    "Sessió";
                breadcrumb.push({
                    nom: pName,
                    nav: `/home/aules/${id_aula}/projectes/${id_projecte}`,
                });
            }

            if (id_tasca) {
                // Cargamos la tasca (antiguo ExerciciId)
                const tData = await GetAulaIdProjecteIdTasquesId(
                    id_aula!,
                    id_projecte!,
                    id_tasca!,
                    userId,
                );
                setTascaSeleccionada(tData);
                breadcrumb.push({
                    nom: tData?.nom || "Exercici",
                    nav: `/home/aules/${id_aula}/projectes/${id_projecte}/exercicis/${id_tasca}`,
                });
            } else {
                setTascaSeleccionada(null);
            }

            setBreadCrumb(breadcrumb, true);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }

    const handleDeleteProjecte = (projId: string) => {
        Modal.confirm({
            title: 'Segur que vols eliminar aquesta sessió?',
            content: 'Aquesta acció no es pot desfer.',
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancel·lar',
            onOk: async () => {
                const res = await DeleteAulaIdProjecte(id_aula + "", projId);
                if (res) {
                    if (id_projecte === projId) navigate(`/home/aules/${id_aula}`);
                    checkDades(true);
                }
            }
        });
    };

    const handleDeleteTasca = (projId: string, tId: string) => {
        Modal.confirm({
            title: 'Segur que vols eliminar aquesta tasca?',
            content: 'Aquesta acció no es pot desfer.',
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancel·lar',
            onOk: async () => {
                const res = await DeleteAulaIdProjectesIdTasques(id_aula + "", projId, tId);
                if (res) {
                    if (id_tasca === tId) navigate(`/home/aules/${id_aula}/projectes/${projId}`);
                    checkDades(true);
                }
            }
        });
    };

    const menuItems = [
        ...(isProfe ? [{
            key: 'nova_sessio',
            icon: <BiPlus />,
            label: 'Nova Sessió',
            onClick: () => { setSelectedProjecte({ id: 0 }); setProjecteModal(true); }
        }] : []),
        ...projectesTasques.map((pt) => ({
            key: `proj-${pt.projecte.id}`,
            icon: <FaTasks />,
            label: (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }} title={pt.projecte.nom || `Sessió ${pt.projecte.id}`}>{pt.projecte.nom || `Sessió ${pt.projecte.id}`}</span>
                    {isProfe && (
                        <Space size={0} onClick={(e) => e.stopPropagation()}>
                            <Button size="small" type="text" icon={<PlusOutlined />} onClick={(e) => { e.stopPropagation(); setSelectedProjecte(pt.projecte); setSelectedTasca({ id: 0 }); setTascaModal(true); }} />
                            <Button size="small" type="text" icon={<EditOutlined />} onClick={(e) => { e.stopPropagation(); setSelectedProjecte(pt.projecte); setProjecteModal(true); }} />
                            <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={(e) => { e.stopPropagation(); handleDeleteProjecte(pt.projecte.id); }} />
                        </Space>
                    )}
                </div>
            ),
            children: pt.tasques.map((t: any) => ({
                key: `tasca-${t.id}`,
                label: (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }} title={t.nom}>{t.nom}</span>
                        {isProfe && (
                            <Space size={0} onClick={(e) => e.stopPropagation()}>
                                <Button size="small" type="text" icon={<EditOutlined />} onClick={(e) => { e.stopPropagation(); setSelectedProjecte(pt.projecte); setSelectedTasca(t); setTascaModal(true); }} />
                                <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={(e) => { e.stopPropagation(); handleDeleteTasca(pt.projecte.id, t.id); }} />
                            </Space>
                        )}
                    </div>
                ),
                onClick: () =>
                    navigate(
                        `/home/aules/${id_aula}/projectes/${pt.projecte.id}/exercicis/${t.id}`,
                    ),
            })),
        })),
    ];

    const isConfiguracio = !id_projecte && !id_tasca;

    const selectedKeys = isConfiguracio
        ? ["configuracio"]
        : id_tasca
            ? [`tasca-${id_tasca}`]
            : [];

    // Acciones de las Tascas (Antiguos Exercicis)
    const normalizeImg = (img?: string | null) => {
        if (!img || img === "undefined" || img === "null")
            return "/images/default.png";
        if (
            img.startsWith("http") ||
            img.startsWith("data:") ||
            img.startsWith("/")
        )
            return img;
        if (img.startsWith("base64:")) img = img.split(":").pop()!;
        if (img.startsWith("/9j/")) return `data:image/jpeg;base64,${img}`;
        if (img.startsWith("iVB")) return `data:image/png;base64,${img}`;
        return `data:image/png;base64,${img}`;
    };

    async function entrarEnCua() {
        setLoading(true);
        await PostDuda(
            id_aula + "",
            userId,
            "-1",
            0,
            0,
            0,
            id_projecte + "",
            id_tasca,
        );
        await checkDades(true);
        setLoading(false);
    }

    async function sortirDeCua(estat: number) {
        setLoading(true);
        await DeleteDuda(id_aula + "", userId, estat);
        await checkDades(true);
        setLoading(false);
    }

    async function openChat() {
        setLoading(true);
        setSelectedRecord({
            id_projecte: id_projecte,
            id_aula: id_aula,
            id_tasca: id_tasca,
            id: 0,
        });
        setChatVisible(true);
        setLoading(false);
    }

    async function checkChatConversa() {
        setLoading(true);
        const record = await GetInteraccionsId(
            userId + "",
            tascaSeleccionada.id_dubte + "",
        );
        setSelectedRecord(record);
        setChatVisible(true);
        setLoading(false);
    }

    async function checkChat() {
        setLoading(true);
        const record = await GetInteraccionsIdTasca(
            userId + "",
            id_aula + "",
            id_tasca + "",
        );
        setSelectedRecord(record);
        setConversaModal(true);
        setLoading(false);
    }

    const HelpSection = ({ tasca }: { tasca: any }) => {
        if (!tasca) return null;
        const selectedItems = tasca?.aula?.ia === 1 ? itemsIA : items;
        const { ia, colab, dudas, cua, newchat, helpchat, cuaprofe } = tasca;

        let msg = null;
        if (ia && colab && dudas) {
            msg = (
                <>
                    Aquest exercici permet utilitzar la IA <PiChats className="inline" />,
                    col·laborar amb companys/es <FaPeopleGroup className="inline" /> i
                    demanar ajuda si tens dubtes{" "}
                    <TbMessageCircleQuestion className="inline" />
                </>
            );
        } else if (dudas && colab) {
            msg = (
                <>
                    Aquest exercici és col·laboratiu <FaPeopleGroup className="inline" />{" "}
                    però pots demanar ajuda <TbMessageCircleQuestion className="inline" />
                </>
            );
        } else if (ia && colab) {
            msg = (
                <>
                    Pots utilitzar la IA <PiChats className="inline" /> o treballar amb
                    companys/es <FaPeopleGroup className="inline" />
                </>
            );
        } else if (ia) {
            msg = (
                <>
                    Aquest exercici permet parlar amb la IA <PiChats className="inline" />
                </>
            );
        } else if (colab) {
            msg = (
                <>
                    Aquest exercici és col·laboratiu <FaPeopleGroup className="inline" />
                </>
            );
        } else if (dudas) {
            msg = (
                <>
                    Pots demanar ajuda si tens dubtes{" "}
                    <TbMessageCircleQuestion className="inline" />
                </>
            );
        }

        if (!msg) return null;

        return (
            <motion.div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 40,
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 24,
                        padding: "24px 32px",
                        borderRadius: 20,
                        background: "rgba(255,255,255,0.65)",
                        backdropFilter: "blur(10px)",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                    }}
                >
                    <motion.img
                        src={
                            ia && colab
                                ? "/images/aicolabavatar1.png"
                                : ia
                                    ? "/images/aiavatar1.png"
                                    : colab
                                        ? "/images/colabavatar1.png"
                                        : "/images/dubtesavatar.png"
                        }
                        alt="Assistant"
                        animate={{ scale: [1, 1.05, 1], rotate: [0, 1, -1, 0] }}
                        transition={{ repeat: Infinity, duration: 4 }}
                        style={{
                            width: 90,
                            height: 90,
                            objectFit: "contain",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            flexShrink: 0,
                        }}
                    />
                    <div style={{ flex: 1 }}>
                        <Typography.Title level={4} style={{ margin: 0, color: "#3B3B3B" }}>
                            {msg}
                        </Typography.Title>
                        <Space wrap style={{ marginTop: 16 }}>
                            {!isProfe && cua && !newchat ? (
                                <Button
                                    type="primary"
                                    loading={buttonLoading}
                                    shape="round"
                                    size="large"
                                    onClick={() => checkChatConversa()}
                                >
                                    <IoChatboxEllipsesOutline /> Veure conversa
                                </Button>
                            ) : null}
                            {!isProfe && cua && newchat ? (
                                <motion.div
                                    animate={{
                                        scale: [1, 1.05, 1],
                                        boxShadow: [
                                            "0 0 0 0 rgba(255,87,34,0.6)",
                                            "0 0 0 10px rgba(255,87,34,0)",
                                            "0 0 0 0 rgba(255,87,34,0)",
                                        ],
                                    }}
                                    transition={{ duration: 1.5, repeat: Infinity }}
                                >
                                    <Button
                                        type="primary"
                                        loading={buttonLoading}
                                        shape="round"
                                        size="large"
                                        onClick={() => checkChatConversa()}
                                    >
                                        <IoChatboxEllipsesOutline /> Veure conversa
                                    </Button>
                                </motion.div>
                            ) : null}
                            {!isProfe && helpchat && colab ? (
                                <motion.div
                                    animate={{
                                        scale: [1, 1.05, 1],
                                        boxShadow: [
                                            "0 0 0 0 rgba(255,87,34,0.6)",
                                            "0 0 0 10px rgba(255,87,34,0)",
                                            "0 0 0 0 rgba(255,87,34,0)",
                                        ],
                                    }}
                                    transition={{ duration: 1.5, repeat: Infinity }}
                                >
                                    <Button
                                        loading={buttonLoading}
                                        shape="round"
                                        type={"primary"}
                                        size="large"
                                        onClick={() => checkChat()}
                                    >
                                        <FaPeopleGroup /> Ajudar companys/es
                                    </Button>
                                </motion.div>
                            ) : null}
                            {!isProfe && ia && !colab && !cua ? (
                                <Button shape="round" size="large" onClick={() => openChat()}>
                                    <PiChats /> Parlar amb la IA
                                </Button>
                            ) : null}
                            {!isProfe && colab && !ia && !cua ? (
                                <Button
                                    loading={buttonLoading}
                                    shape="round"
                                    size="large"
                                    onClick={() => openChat()}
                                >
                                    <FaPeopleGroup /> Preguntar a companys/es
                                </Button>
                            ) : null}
                            {!isProfe && colab && ia && !cua ? (
                                <Button
                                    shape="round"
                                    loading={buttonLoading}
                                    size="large"
                                    onClick={() => openChat()}
                                >
                                    <FaPeopleGroup />
                                    <PiChats /> Preguntar a companys/es o a la IA
                                </Button>
                            ) : null}
                            {!isProfe && dudas && !cuaprofe ? (
                                <Button
                                    shape="round"
                                    loading={buttonLoading}
                                    size="large"
                                    onClick={() => entrarEnCua()}
                                >
                                    <TbMessageCircleQuestion />
                                    Tinc un dubte
                                </Button>
                            ) : null}
                            {!isProfe && dudas && cuaprofe ? (
                                <>
                                    <Button shape="round" size="large" loading={true}>
                                        <TbMessageCircleQuestion />
                                        en cua...
                                    </Button>
                                    <Dropdown
                                        menu={{
                                            items: selectedItems,
                                            onClick: (e) => sortirDeCua(-1 - parseInt(e.key)),
                                        }}
                                    >
                                        <Button
                                            icon={<GiCancel />}
                                            loading={buttonLoading}
                                            shape="round"
                                            type={"default"}
                                        >
                                            <Space>
                                                Sortir de cua...
                                                <DownOutlined />
                                            </Space>
                                        </Button>
                                    </Dropdown>
                                </>
                            ) : null}
                            {isProfe && !helpchat && !dudas ? (
                                <Button
                                    loading={buttonLoading}
                                    shape="round"
                                    size="large"
                                    onClick={() => checkChat()}
                                >
                                    <IoChatboxEllipsesOutline /> Veure converses
                                </Button>
                            ) : null}
                            {isProfe && helpchat && !dudas ? (
                                <motion.div
                                    animate={{
                                        scale: [1, 1.05, 1],
                                        boxShadow: [
                                            "0 0 0 0 rgba(255,87,34,0.6)",
                                            "0 0 0 10px rgba(255,87,34,0)",
                                            "0 0 0 0 rgba(255,87,34,0)",
                                        ],
                                    }}
                                    transition={{ duration: 1.5, repeat: Infinity }}
                                >
                                    <Button
                                        type="primary"
                                        loading={buttonLoading}
                                        shape="round"
                                        size="large"
                                        onClick={() => checkChat()}
                                    >
                                        <IoChatboxEllipsesOutline /> Hi ha noves converses!
                                    </Button>
                                </motion.div>
                            ) : null}
                            {isProfe && dudas && tasca?.dubtes?.length > 0 ? (
                                <motion.div
                                    animate={{
                                        scale: [1, 1.05, 1],
                                        boxShadow: [
                                            "0 0 0 0 rgba(255,87,34,0.6)",
                                            "0 0 0 10px rgba(255,87,34,0)",
                                            "0 0 0 0 rgba(255,87,34,0)",
                                        ],
                                    }}
                                    transition={{ duration: 1.5, repeat: Infinity }}
                                >
                                    <Button
                                        type="primary"
                                        loading={buttonLoading}
                                        shape="round"
                                        size="large"
                                        onClick={() => setDubtesModal(true)}
                                    >
                                        <IoChatboxEllipsesOutline />
                                        {`Tens ${tasca?.dubtes?.length} dubte${tasca?.dubtes?.length > 1 ? "s" : ""}!`}
                                    </Button>
                                </motion.div>
                            ) : null}
                        </Space>
                    </div>
                </div>
            </motion.div>
        );
    };

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sider
                style={{ background: colorBgContainer, overflowY: "auto" }}
                width={300}
            >
                <Menu
                    mode="inline"
                    defaultOpenKeys={projectesTasques.map((p) => `proj-${p.projecte.id}`)}
                    selectedKeys={selectedKeys}
                    style={{ height: "100%", borderRight: 0 }}
                    items={menuItems}
                />
            </Sider>

            <Content style={{ padding: "32px" }}>
                {isProfe && (
                    <div
                        style={{
                            display: "flex",
                            gap: "12px",
                            marginBottom: "24px",
                            flexWrap: "wrap",
                        }}
                    >

                        <Button
                            type="default"
                            icon={<BiRefresh />}
                            onClick={() => checkDades(true)}
                        >
                            Refrescar
                        </Button>
                    </div>
                )}

                {loading && (
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.3 }}
                        style={{
                            position: "fixed",
                            top: 136,
                            left: "50%",
                            transform: "translateX(-20%)",
                            zIndex: 2000,
                            pointerEvents: "none",
                        }}
                    >
                        <Tag
                            color="blue"
                            style={{
                                fontSize: 15,
                                padding: "6px 30px",
                                borderRadius: 16,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                background: "rgba(255,255,255,0.9)",
                                backdropFilter: "blur(6px)",
                            }}
                        >
                            🔄 Cargando...
                        </Tag>
                    </motion.div>
                )}

                {isConfiguracio || !id_tasca ? (
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "75vh",
                            textAlign: "center",
                        }}
                    >
                        <motion.img
                            src={aula?.img ? normalizeImg(aula?.img) : "/images/default.png"}
                            alt="Aula"
                            style={{
                                width: 180,
                                height: 180,
                                borderRadius: "50%",
                                objectFit: "cover",
                                boxShadow: "0 6px 24px rgba(0,0,0,0.15)",
                                marginBottom: 24,
                            }}
                            animate={{ scale: [1, 1.05, 1], rotate: [0, 1, -1, 0] }}
                            transition={{ duration: 4, repeat: Infinity }}
                        />
                        <Title level={3} style={{ color: "#333" }}>
                            Selecciona un exercici
                        </Title>
                    </motion.div>
                ) : (
                    tascaSeleccionada && (
                        <>
                            <HelpSection tasca={tascaSeleccionada} />
                            <Card
                                style={{
                                    maxWidth: 800,
                                    margin: "0 auto",
                                    borderRadius: 12,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                }}
                            >
                                <Space align="start" size="large">
                                    <Avatar
                                        src={normalizeImg(tascaSeleccionada.img)}
                                        size={100}
                                        shape="square"
                                        style={{ borderRadius: 12 }}
                                    />
                                    <div>
                                        <Title level={3} style={{ marginBottom: 8 }}>
                                            {tascaSeleccionada.nom}
                                        </Title>
                                        <Space wrap>
                                            {tascaSeleccionada.colab ? (
                                                <Tag color="blue">Col·laboratiu</Tag>
                                            ) : (
                                                <></>
                                            )}
                                            {tascaSeleccionada.ia ? (
                                                <Tag color="purple">IA</Tag>
                                            ) : (
                                                <></>
                                            )}
                                            {tascaSeleccionada.dudas ? (
                                                <Tag color="orange">Dubtes</Tag>
                                            ) : (
                                                <></>
                                            )}
                                            {tascaSeleccionada.copypaste ? (
                                                <Tag color="red">Copypaste</Tag>
                                            ) : (
                                                <></>
                                            )}
                                        </Space>
                                    </div>
                                </Space>
                                <Paragraph
                                    style={{ marginTop: 24, fontSize: 16, lineHeight: 1.6 }}
                                >
                                    <ReactMarkdown
                                        remarkPlugins={[remarkGfm, remarkBreaks]}
                                        rehypePlugins={[rehypeRaw]}
                                    >
                                        {tascaSeleccionada.enunciat || "Sense descripció"}
                                    </ReactMarkdown>
                                </Paragraph>
                            </Card>
                        </>
                    )
                )}
            </Content>

            <ProjecteModal
                visible={projecteModal}
                onClose={() => {
                    setProjecteModal(false);
                    checkDades(true);
                }}
                element={selectedProjecte}
            />
            {tascaModal && (
                <TascaModal
                    visible={tascaModal}
                    onClose={() => {
                        setTascaModal(false);
                        checkDades(true);
                    }}
                    alumnes={[]}
                    element={selectedTasca}
                    selectedIds={[]}
                    id_projecte={selectedProjecte?.id}
                    id_aula={id_aula}
                />
            )}
            {dudaTextoModal && (
                <DudaTextoModal
                    visible={dudaTextoModal}
                    onClose={() => {
                        setDudaTextoModal(false);
                        setLoading(false);
                    }}
                    copypaste={tascaSeleccionada?.copypaste}
                    loading={modalLoading}
                    onSubmit={async () => {
                        setModalLoading(true);
                        await entrarEnCua();
                        setModalLoading(false);
                        setDudaTextoModal(false);
                    }}
                />
            )}
            {chatVisible && (
                <ChatModal
                    modalVisible={chatVisible}
                    onClose={() => {
                        setChatVisible(false);
                        checkDades(true);
                    }}
                    setModalVisible={() => setChatVisible(false)}
                    tasca={true}
                    copypaste={tascaSeleccionada?.copypaste}
                    selectedRecord={selectedRecord}
                />
            )}
            {conversaModal && (
                <ChatTableModal
                    visible={conversaModal}
                    onClose={() => {
                        setConversaModal(false);
                        setLoading(false);
                    }}
                    isTasca={true}
                    aula={aula}
                />
            )}
            {dubtesModal && (
                <CuaModal
                    modalVisible={dubtesModal}
                    setModalVisible={() => setDubtesModal(false)}
                    selectedRecord={aula}
                />
            )}
        </Layout>
    );
};
export default AulesId;
